<template>
  <div
    class="cn-drawer-wrapper"
    :class="{ 'cn-drawer-wrapper--visible': modelValue }"
  >
    <div class="cn-drawer">
      <div class="cn-drawer__block">
        <div class="cn-drawer__header">
          <div class="container">
            <div class="cn-drawer__header-block">
              <div class="cn-drawer__title text-lg font-bold">{{ title }}</div>
              <button class="cn-drawer__close" @click="close">
                <UiIcon name="close" />
              </button>
            </div>
          </div>
        </div>
        <div class="cn-drawer__content">
          <div class="container">
            <slot />
          </div>
        </div>
        <div class="cn-drawer__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBodyScrollLock } from '@/composables';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  modelValue: boolean;
  title: string;
}
const props = defineProps<Props>();
useBodyScrollLock(() => props.modelValue);
const emit = defineEmits<{
  (e: 'update:modelValue', data: boolean): void;
}>();

const close = () => {
  emit('update:modelValue', false);
};
</script>

<style lang="scss">
.cn-drawer-wrapper {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  z-index: 30;
  top: 0px;
  right: 100%;
  bottom: 0px;
  position: fixed;
  &--visible {
    transform: translate(100%, 0);
  }
}
.cn-drawer {
  --ab-canyon-drawer-color-bg: var(--ab-canyon-color-light);
  --ab-canyon-drawer-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-drawer-color-border: var(--ab-canyon-color-neutral-light);

  width: 100vw;
  height: 100%;
  background-color: var(--ab-canyon-drawer-color-bg);
  color: var(--ab-canyon-drawer-color-text);
  &__block {
    flex-direction: column;
    height: 100%;
    display: flex;
  }
  &__header {
    z-index: 40;
    padding: var(--size-base) 0;
    border-bottom: 1px solid var(--ab-canyon-drawer-color-border);
  }
  &__header-block {
    justify-content: space-between;
    align-items: center;
    display: flex;
  }
  &__title {
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  &__close {
    .cn-icon {
      width: var(--size-xl);
      height: var(--size-xl);
    }
  }
  &__content {
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
    overflow-y: auto;
    flex-grow: 1;
  }
  &__footer {
    background-color: var(--ab-canyon-draver-color-text);
    z-index: 40;
    padding: var(--size-base);
  }
}
</style>
